import React, { Fragment } from 'react';
import { Field } from 'formik';
import Input from '@lightspeed/cirrus-input';
import Select from '@lightspeed/cirrus-select';
import FormField from 'cirrus/FormField';
import {
  TERMINAL_TYPE,
  TERMINAL_ATTRIBUTES,
  TERMINAL_PAIRING_METHOD,
} from 'shared_modules/Terminals';
import Text from '@lightspeed/cirrus-text';

const STRINGS = {
  INSTRUCTIONS: {
    STRIPE:
      'To see the registration code, press the following digits on the PIN pad of the Terminal: 0 7 1 3 9',
    STRIPE_WISEPOSE:
      'To generate your activation code, swipe the terminal screen from left edge to right edge. Tap Settings ' +
      'and enter the admin code 0 7 1 3 9 when prompted. Tap "Generate pairing code" to obtain your activation code.',
    ADYEN:
      'The serial number is located on the original packaging or the back of the device you are trying to pair.',
    DEFAULT: '',
  },
};

const getInstructions = terminalModel => {
  if (
    [
      TERMINAL_TYPE.LIGHTSPEED_V400M_ADYEN,
      TERMINAL_TYPE.LIGHTSPEED_P400_PLUS_ADYEN,
      TERMINAL_TYPE.LIGHTSPEED_E285_ADYEN,
      TERMINAL_TYPE.LIGHTSPEED_M400_ADYEN,
    ].includes(terminalModel)
  ) {
    return STRINGS.INSTRUCTIONS.ADYEN;
  }

  if ([TERMINAL_TYPE.LIGHTSPEED_P400_PLUS_STRIPE].includes(terminalModel)) {
    return STRINGS.INSTRUCTIONS.STRIPE;
  }

  if ([TERMINAL_TYPE.LIGHTSPEED_BBPOS_WISEPOSE_STRIPE].includes(terminalModel)) {
    return STRINGS.INSTRUCTIONS.STRIPE_WISEPOSE;
  }

  return STRINGS.INSTRUCTIONS.DEFAULT;
};

export const getStatus = (fieldName, { touched, errors }) => {
  if (touched[fieldName] && errors[fieldName]) {
    return { type: 'error', message: errors[fieldName] };
  }

  return {};
};

const CCTerminalForm = ({ apiErrors, supportedTerminalTypes }) => (
  <Fragment>
    <FormField className="cr-mb-2">
      <Field
        name="name"
        render={({ field, form }) => (
          <Input
            {...field}
            type="text"
            label="Terminal Name"
            data-test="retail-payments-ccterminal-name"
            className="cr-width-full"
            status={getStatus('name', form, apiErrors)}
            maxLength="50"
          />
        )}
      />
    </FormField>
    {supportedTerminalTypes && (
      <FormField className="cr-mb-2">
        <label htmlFor="settlement_status_filter">
          <Text bodySmall bold>
            Terminal Model
          </Text>
        </label>
        <Field
          name="terminalModel"
          render={({ field, form }) => (
            <Select
              {...field}
              label="Terminal Model"
              data-test="retail-payments-ccterminal-type"
              status={getStatus('terminalModel', form, apiErrors)}
            >
              {supportedTerminalTypes.map(terminalType => {
                return (
                  <option key={terminalType} value={terminalType} className="notranslate">
                    {TERMINAL_ATTRIBUTES[terminalType].name}
                  </option>
                );
              })}
            </Select>
          )}
        />
      </FormField>
    )}
    <FormField>
      <Field
        name="pairingInput"
        render={({ field, form }) => (
          <Input
            {...field}
            type="text"
            data-test="retail-payments-ccterminal-pairingInput"
            label={
              TERMINAL_ATTRIBUTES[form.values.terminalModel]?.pairingMethod ===
              TERMINAL_PAIRING_METHOD.SERIAL_NUMBER
                ? 'Serial Number'
                : 'Activation Code'
            }
            className="cr-width-full"
            autoComplete="off"
            status={getStatus('pairingInput', form, apiErrors)}
            description={getInstructions(form.values.terminalModel)}
          />
        )}
      />
    </FormField>
  </Fragment>
);

export default CCTerminalForm;
